import CustomField from '../CustomField';
import terminology from 'javascripts/terminology';

function getExampleContent(fieldType) {
  const exampleContent = {
    // These fields are not supported in Develop yet, but we need to show examples
    // for Roadmap layouts
    CompetitorsField: 'Example competitor',
    CreativeBriefsField: 'Example creative brief',
    EpicsField: `Example ${terminology('epic')}`,
    FeaturesField: `Example ${terminology('feature')}`,
    IdeaCategoriesField: `Example ${terminology('idea')} category`,
    IdeaOrganizationsField: 'Example organization',
    IdeasField: `Example ${terminology('idea')}`,
    InitiativesField: `Example ${terminology('initiative')}`,
    PersonasField: 'Example persona',
    ProjectsField: `Example ${terminology('product')}`,
    ReleasesField: `Example ${terminology('release')}`,
    StrategicImperativesField: `Example ${terminology('goal')}`,
    UsersField: 'Example user',
  };

  return exampleContent[fieldType];
}

export default class RecordCustomField extends CustomField {
  exampleContents() {
    const exampleContent = getExampleContent(this.customFieldDefinition.type);

    return {
      text: exampleContent,
    };
  }

  contentsForRecord(record) {
    const customFieldValue = this.customFieldValueForRecord(record);

    if (customFieldValue?.humanValue || customFieldValue?.value) {
      return {
        text: customFieldValue.humanValue || customFieldValue.value,
      };
    }

    return {};
  }
}
